__webpack_require__.p = "https://ikea.marat.qd.je/se/en/customer-service/support/";